import { formatFileSize } from "./format-size.ts";

export const MAX_DOCUMENT_SIZE = 52_428_800;

export const DOCUMENT_CONTENT_TYPES: Record<string, string> = {
	".pdf": "application/pdf",
	".jpg": "image/jpeg",
	".jpeg": "image/jpeg",
	".png": "image/png",
	".webp": "image/webp",
	".dwg": "image/vnd.dwg",
	".dxf": "image/vnd.dxf",
	".doc": "application/msword",
	".docx":
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	".xls": "application/vnd.ms-excel",
	".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const DOCUMENT_EXTENSIONS = Object.keys(DOCUMENT_CONTENT_TYPES);

export const DOCUMENT_ACCEPT = DOCUMENT_EXTENSIONS.join(",");

export type DocumentFileKind = "pdf" | "image" | "drawing" | "text" | "sheet";

const KIND_BY_EXTENSION: Record<string, DocumentFileKind> = {
	".pdf": "pdf",
	".jpg": "image",
	".jpeg": "image",
	".png": "image",
	".webp": "image",
	".dwg": "drawing",
	".dxf": "drawing",
	".doc": "text",
	".docx": "text",
	".xls": "sheet",
	".xlsx": "sheet",
};

export function fileExtension(fileName: string): string {
	const dot = fileName.lastIndexOf(".");
	if (dot <= 0 || dot === fileName.length - 1) return "";
	return fileName.slice(dot).toLowerCase();
}

export function fileTitle(fileName: string): string {
	const dot = fileName.lastIndexOf(".");
	return dot > 0 ? fileName.slice(0, dot) : fileName;
}

export function isAllowedDocument(fileName: string): boolean {
	return fileExtension(fileName) in DOCUMENT_CONTENT_TYPES;
}

export function documentFileKind(fileName: string): DocumentFileKind {
	return KIND_BY_EXTENSION[fileExtension(fileName)] ?? "text";
}

export function documentFileError(file: {
	name: string;
	size: number;
}): string | undefined {
	if (!isAllowedDocument(file.name)) {
		return "Formato não suportado. Envie PDF, imagem, DWG, DXF, Word ou Excel.";
	}
	if (file.size <= 0) {
		return "O arquivo está vazio.";
	}
	if (file.size > MAX_DOCUMENT_SIZE) {
		return `O arquivo passa do limite de ${formatFileSize(MAX_DOCUMENT_SIZE)}.`;
	}
	return undefined;
}
